import React from 'react';
import "./AboutPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import MultiCarousel from "../../Common/LogoCarousel";
import {about_us,About_Us_Text} from "../../data";
import Founders from '../../Common/Founder';


function App() {
  return <X02AboutPageMobile {...x02AboutPageMobileData} />;
}

export default App;

function X02AboutPageMobile(props) {
  const {
    aboutUs,
    rectangle76,
    text1,
    text12,
    text13,
    text14,
    text15,
    text16,
    text17,
    whyChooseUs,
    line55,
    vector2,
    vector3,
    place,
    vector4,
    vector5,
    vector6,
    vector7,
    vector8,
    vector9,
    vector10,
    vector11,
    vector12,
    vector13,
    vector14,
    vector15,
    vector16,
    vector17,
    vector18,
    vector19,
    vector20,
    vector21,
    vector22,
    vector23,
    vector24,
    vector25,
    vector26,
    vector27,
    vector28,
    vector29,
    vector30,
    vector31,
    vector32,
    vector33,
    vector34,
    vector35,
    vector36,
    vector37,
    vector38,
    vector39,
    vector40,
    vector41,
    vector42,
    transparency,
    vector43,
    vector44,
    cost,
    rectangle72,
    place2,
    text3,
    rectangle73,
    transparenccy,
    text4,
    rectangle70,
    cost2,
    text5,
    rectangle77,
    whyWebuild,
    text2,
    whyWebuild2,
    image3,
    image5,
    image4,
    frame145Props,
    founderCardProps,
    founderCard32Props,
    founderCard2Props,
    founderCard4Props,
    group8622Props,
    group87Props,
    group32Props,
    frame5Props,
  } = props;

  return (
    <div className="apm-container-center-horizontal">
      <div className="apm-x02-about-page-mobile apm-screen">
        {/* <Frame145 group86Props={frame145Props.group86Props} iconMenuProps={frame145Props.iconMenuProps} /> */}
        <NavBar/>
        <h1 className="apm-title apm-valign-text-middle apm-typographyheadlineh4-extrabold-24">{aboutUs}</h1>
        {/* <img className="apm-rectangle-76" src={rectangle76} /> */}
        <img className="apm-rectangle-76" src={about_us.AboutUsHeader} />
        <div className="apm-vision-mission">
          <p> Vision Statement : To accelerate and furnish your ideal space through quality innovation.</p>
          <p> Mission Statement : Constructing dreams transparently, at an effective cost with quality, just as we promised. </p>
        </div>
        <div className="apm-text-1 apm-typography-body-smalltext-14-regular">
          <p>{text1}</p>
          <p>{text12}</p>
          <p>{text13}</p>
          <p>{text14}</p>
          <p>{text15}</p> 
          <p>{text16}</p>
          <p>{text17}</p>
        </div>
        <div className="apm-why-choose-us apm-valign-text-middle apm-typographyheadlineh4-extrabold-24">{whyChooseUs}</div>
        <div className="apm-group-154">
          <div className="apm-overlap-group">
            <img className="apm-line-55" src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-55-2@2x.svg" />
            <div className="apm-frame-1605">
              <div className="apm-group-151">
                      {/* <img
                        className="apm-vector"
                        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-113@2x.svg"
                      /> */}
                      <img
                        src={about_us.AboutQualityIcon}
                        height='80px'
                        width='80px'
                      />
                      
                <div className="apm-place apm-valign-text-middle apm-typographyheadlineh5-extrabold-20">{place}</div>
              </div>
              <div className="apm-group-15">
                <img 
                src={about_us.AboutTransparencyIcon}
                height='80px'
                width='80px'
                />
                <div className="apm-transparency apm-valign-text-middle apm-typographyheadlineh5-extrabold-20">{transparency}</div>
              </div>
              <div className="apm-group-15">
                {/* <div className="apm-group-14 apm-border-1px-red">
                  <div className="apm-money-bag">
                    <div className="apm-overlap-group1-2">
                      <img className="apm-vector-42" src={vector43} />
                      <img className="apm-vector-43" src={vector44} />
                    </div>
                  </div>
                </div> */}
                <img
                src={about_us.AboutCostIcon}
                height='80px'
                width='80px'
                />
                <div className="apm-cost apm-valign-text-middle apm-typographyheadlineh5-extrabold-20">{cost}</div>
              </div>
            </div>
          </div>
        </div>
        {/* <img className="apm-rectangle-7" src={rectangle72} /> */}
        <img className="apm-rectangle-7" src={about_us.AboutQuality} alt="Webuildd Quality" />
        <div className="apm-place-1 apm-valign-text-middle apm-typographyheadlineh5-extrabold-20">{place2}</div>
        <p className="apm-text-3 apm-typographybodysmall-12-regular">{text3}</p>
        {/* <img className="apm-rectangle-7" src={rectangle73} /> */}
        <img className="apm-rectangle-7" src={about_us.AboutTransparency} alt="Webuildd Transparency" />
        <div className="apm-x02-about-page-mobile-item apm-typographyheadlineh4-extrabold-24">{transparenccy}</div>
        <p className="apm-text-4 apm-typography-body-smalltext-14-regular">{text4}</p>
        {/* <img className="apm-rectangle-7" src={rectangle70} /> */}
        <img className="apm-rectangle-7" src={about_us.AboutCost} alt="Webuildd Cost" />
        <div className="apm-x02-about-page-mobile-item apm-typographyheadlineh4-extrabold-24">{cost2}</div>
        <p className="apm-text-5 apm-typographybodysmall-12-regular">{text5}</p>
        
        <img className="apm-rectangle-7" src={about_us.Experience} alt="Webuildd Quality" />
        <div className="apm-place-1 apm-valign-text-middle apm-typographyheadlineh5-extrabold-20">{About_Us_Text.Experience_Text_Head}</div>
        <p className="apm-text-3 apm-typographybodysmall-12-regular">{About_Us_Text.Experience_Text}</p>
        {/* <img className="apm-rectangle-7" src={rectangle73} /> */}
        <img className="apm-rectangle-7" src={about_us.Warranty} alt="Webuildd Transparency" />
        <div className="apm-x02-about-page-mobile-item apm-typographyheadlineh4-extrabold-24">{About_Us_Text.Warranty_Text_Head}</div>
        <p className="apm-text-4 apm-typography-body-smalltext-14-regular">{About_Us_Text.Warranty_Text}</p>

        <img className="apm-rectangle-7" src={about_us.Completion} alt="Webuildd Quality" />
        <div className="apm-place-1 apm-valign-text-middle apm-typographyheadlineh5-extrabold-20">{About_Us_Text.Completion_Text_Head}</div>
        <p className="apm-text-3 apm-typographybodysmall-12-regular">{About_Us_Text.Completion_Text}</p>
        {/* <img className="apm-rectangle-7" src={rectangle73} /> */}
        <img className="apm-rectangle-7" src={about_us.SOPC} alt="Webuildd Transparency" />
        <div className="apm-x02-about-page-mobile-item apm-typographyheadlineh4-extrabold-24">{About_Us_Text.SOPC_Text_Head}</div>
        <p className="apm-text-4 apm-typography-body-smalltext-14-regular">{About_Us_Text.SOPC_Text}</p>

        
        {/* <img className="apm-rectangle-77" src={rectangle77} /> */}
        {/* <img className="apm-rectangle-77" src={about_us.AboutHowItWorks} /> */}
        {/* <div className="apm-why-webuild apm-valign-text-middle apm-typographyheadlineh4-extrabold-24">{whyWebuild}</div>
        <p className="apm-text-2 apm-typography-body-smalltext-14-regular">{text2}</p> */}
        <div className="apm-why-webuild-1 apm-valign-text-middle apm-typographyheadlineh4-extrabold-24">{whyWebuild2}</div>
        <div className="apm-frame-1606">
          <Founders />
          {/* <FounderCard
            rectangle90={founderCardProps.rectangle90}
            name={founderCardProps.name}
            designation={founderCardProps.designation}
          />
          <FounderCard32
            rectangle90={founderCard32Props.rectangle90}
            name={founderCard32Props.name}
            designation={founderCard32Props.designation}
          />
          <FounderCard2
            rectangle90={founderCard2Props.rectangle90}
            name={founderCard2Props.name}
            designation={founderCard2Props.designation}
          />
          <FounderCard4
            rectangle90={founderCard4Props.rectangle90}
            name={founderCard4Props.name}
            designation={founderCard4Props.designation}
          /> */}
        </div>
        <div className="apm-group-212">
          <div className="apm-overlap-group5-1">
            {/* <img className="apm-image-3" src={image3} />
            <img className="apm-image" src={image5} />
            <img className="apm-image" src={image4} /> */}

            {/* <img className="apm-image-3" src={about_us.GreyBG1} />
            <img className="apm-image" src={about_us.GreyBG2} />
            <img className="apm-image" src={about_us.GreyBG3} /> */}
            <MultiCarousel/>
          </div>
          {/* <div className="apm-overlap-group6"> */}
            {/* <div className="apm-flex-row-1"> */}
              {/* <Group8622 group85={group8622Props.group85} /> */}
              {/* <Group87
                facebookAppSymbolProps={group87Props.facebookAppSymbolProps}
                facebookAppSymbolProps2={group87Props.facebookAppSymbolProps2}
                twitterProps={group87Props.twitterProps}
              /> */}
            {/* </div> */}
            {/* <Group32 {...group32Props} /> */}
            {/* <Frame5
              quickLinks={frame5Props.quickLinks}
              frame140Props={frame5Props.frame140Props}
              frame1402Props={frame5Props.frame1402Props}
              frame1403Props={frame5Props.frame1403Props}
            /> */}
           
          {/* </div> */}
          <Footer/>
        </div>
      </div>
    </div>
  );
}


function Frame145(props) {
  const { group86Props, iconMenuProps } = props;

  return (
    <div className="apm-frame-145">
      <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
      <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} />
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="apm-group-86">
      <White src={whiteProps.src} />
      <img className="apm-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="apm-white">
      <img className="apm-vector-44" src={src} />
    </div>
  );
}


function IconMenu(props) {
  const { vector2, vector3 } = props;

  return (
    <div className="apm-icon-menu">
      <img
        className="apm-vector-46"
        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
      />
      <img className="apm-vector-45" src={vector2} />
      <img className="apm-vector-45" src={vector3} />
    </div>
  );
}


function FounderCard(props) {
  const { rectangle90, name, designation } = props;

  return (
    <div className="apm-founder-card">
      <img className="apm-rectangle-90" src={rectangle90} />
      <div className="apm-group-99">
        <div className="apm-name apm-valign-text-middle apm-typographyheadlineh4-extrabold-24">{name}</div>
        <div className="apm-designation apm-typography-body-smalltext-14-regular">{designation}</div>
      </div>
    </div>
  );
}


function FounderCard32(props) {
  const { rectangle90, name, designation } = props;

  return (
    <div className="apm-founder-card-1">
      <img className="apm-rectangle-90-1" src={rectangle90} />
      <div className="apm-group-99-1">
        <div className="apm-name-1 apm-valign-text-middle apm-typographyheadlineh4-extrabold-24">{name}</div>
        <div className="apm-designation-1 apm-typography-body-smalltext-14-regular">{designation}</div>
      </div>
    </div>
  );
}


function FounderCard2(props) {
  const { rectangle90, name, designation } = props;

  return (
    <div className="apm-founder-card-2">
      <img className="apm-rectangle-90-2" src={rectangle90} />
      <div className="apm-group-99-2">
        <div className="apm-name-2 apm-valign-text-middle apm-typographyheadlineh4-extrabold-24">{name}</div>
        <div className="apm-designation-2 apm-typography-body-smalltext-14-regular">{designation}</div>
      </div>
    </div>
  );
}


function FounderCard4(props) {
  const { rectangle90, name, designation } = props;

  return (
    <div className="apm-founder-card-3">
      <img className="apm-rectangle-90-3" src={rectangle90} />
      <div className="apm-group-99-3">
        <div className="apm-name-3 apm-valign-text-middle apm-typographyheadlineh4-extrabold-24">{name}</div>
        <div className="apm-designation-3 apm-typography-body-smalltext-14-regular">{designation}</div>
      </div>
    </div>
  );
}


function Group8622(props) {
  const { group85 } = props;

  return (
    <div className="apm-group-86-1">
      <div className="apm-white-1">
        <img
          className="apm-vector-47"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
        />
      </div>
      <img className="apm-group-85-1" src={group85} />
    </div>
  );
}


function Group87(props) {
  const { facebookAppSymbolProps, facebookAppSymbolProps2, twitterProps } = props;

  return (
    <div className="apm-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <Instagram instagram={facebookAppSymbolProps2.instagram} vector2={facebookAppSymbolProps2.vector2} />
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div className="apm-facebook-app-symbol">
      <img className="apm-f-1" src={src} />
    </div>
  );
}


function Instagram(props) {
  const { instagram, vector2 } = props;

  return (
    <div className="apm-instagram" style={{ backgroundImage: `url(${instagram})` }}>
      <div className="apm-overlap-group-1">
        <img
          className="apm-vector-48"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-155@2x.svg"
        />
        <img className="apm-vector-49" src={vector2} />
      </div>
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div className="apm-twitter">
      <img className="apm-vector-50" src={src} />
    </div>
  );
}


function Group32(props) {
  const { place, overlapGroup4, phone, overlapGroup5, vector2, text21, text20, contactWebuildCom } = props;

  return (
    <div className="apm-group-32">
      <div className="apm-place-2 apm-valign-text-middle apm-typographyheadlineh5-extrabold-20">{place}</div>
      <div className="apm-flex-row-2">
        <div className="apm-flex-col">
          <div className="apm-map-pin-1">
            <div className="apm-overlap-group-2" style={{ backgroundImage: `url(${overlapGroup4})` }}>
              <img
                className="apm-vector-51"
                src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-150@2x.svg"
              />
            </div>
          </div>
          <div className="apm-phone" style={{ backgroundImage: `url(${phone})` }}></div>
          <div className="apm-mail">
            <div className="apm-overlap-group1-3" style={{ backgroundImage: `url(${overlapGroup5})` }}>
              <img className="apm-vector-52" src={vector2} />
            </div>
          </div>
        </div>
        <div className="apm-flex-col-1">
          <p className="apm-text-7 apm-typography-body-smalltext-14-regular">{text21}</p>
          <div className="apm-flex-col-item apm-valign-text-middle apm-typography-body-smalltext-14-regular">{text20}</div>
          <div className="apm-flex-col-item apm-valign-text-middle apm-typography-body-smalltext-14-regular">
            {contactWebuildCom}
          </div>
        </div>
      </div>
    </div>
  );
}


function Frame5(props) {
  const { quickLinks, frame140Props, frame1402Props, frame1403Props } = props;

  return (
    <div className="apm-frame-5">
      <div className="apm-quick-links apm-valign-text-middle apm-typographyheadlineh5-extrabold-20">{quickLinks}</div>
      <div className="apm-frame-4">
        <Frame140 aboutUs={frame140Props.aboutUs} projects={frame140Props.projects} />
        <Frame140
          aboutUs={frame1402Props.aboutUs}
          projects={frame1402Props.projects}
          className={frame1402Props.className}
        />
        <Frame140
          aboutUs={frame1403Props.aboutUs}
          projects={frame1403Props.projects}
          className={frame1403Props.className}
        />
      </div>
    </div>
  );
}


function Frame140(props) {
  const { aboutUs, projects, className } = props;

  return (
    <div className={`apm-frame-140 ${className || ""}`}>
      <div className="apm-about-us apm-valign-text-middle apm-typographybody16-regular">{aboutUs}</div>
      <div className="apm-projects apm-valign-text-middle apm-typographybody16-regular">{projects}</div>
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg",
    whiteProps: whiteData,
};

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame145Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};

const founderCardData = {
    rectangle90: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-90@2x.png",
    name: "Jenny Wilson",
    designation: "Designation",
};

const founderCard32Data = {
    rectangle90: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-90-2@2x.png",
    name: "Esther Howard",
    designation: "Designation",
};

const founderCard2Data = {
    rectangle90: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-90-1@2x.png",
    name: "Brooklyn Simmons",
    designation: "Designation",
};

const founderCard4Data = {
    rectangle90: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-90-3@2x.png",
    name: "Jane Cooper",
    designation: "Designation",
};

const group8622Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
};

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
};

const instagramData = {
    instagram: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-223@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-409@2x.svg",
};

const twitterData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-347@2x.svg",
};

const group87Data = {
    facebookAppSymbolProps: facebookAppSymbolData,
    facebookAppSymbolProps2: instagramData,
    twitterProps: twitterData,
};

const group32Data = {
    place: "Contact",
    overlapGroup4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-374@2x.svg",
    phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-151@2x.svg",
    overlapGroup5: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-318@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-111@2x.svg",
    text21: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
    text20: "+91 8976535221, +91 8755645342",
    contactWebuildCom: "contact@webuild.com",
};

const frame140Data = {
    aboutUs: "About Us",
    projects: "Projects",
};

const frame1402Data = {
    aboutUs: "Gallery",
    projects: "Knowledge Transfer",
    className: "apm-frame-14-1",
};

const frame1403Data = {
    aboutUs: "Blogs",
    projects: "FAQ’s",
    className: "apm-frame-14",
};

const frame5Data = {
    quickLinks: "Quick Links",
    frame140Props: frame140Data,
    frame1402Props: frame1402Data,
    frame1403Props: frame1403Data,
};

const x02AboutPageMobileData = {
    aboutUs: "About Us",
    rectangle76: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-76-7@2x.png",
    text1: "WeBuildd is a third-generation family-owned construction company located in Bangalore. As a fully integrated firm, we have our in-house team of Architects, Structural Engineers, Contractors/Builders, Interior Designers, and Consultants to make your visions come true.",
    text12:"With our strong technical knowledge in the construction industry, we have developed properties across all asset classes including, industrial, manufacturing, biotech, residential, healthcare, education, mixed‐use, and retail.",
    text13:"We have invested countless hours in the relentless pursuit of building better and smart homes and commercial properties through our quality-conscious, money-saving, thoughtful designs, as well as transparent, higher building standards.",
    text14:"Our objective has been to make the construction process enjoyable for our consumers since the beginning of our adventure.",
    text15:"We give the customers the ability to personalize their visions from floor plans and construction materials to furniture cabinets at a price that fits their budget without compromising the quality.",
    text16:"We also help our customers to sort through residential & commercial building requirements, ranging from government plan approvals, architectural plans, construction, io interior solutions.",
    text17:"To begin your journey with us, use our online construction calculator to get a glimpse into our process and the financials involved.",
    whyChooseUs: "Founders",
    line55: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-55-2@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-114@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-286@2x.svg",
    place: "Quality",
    vector4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-116@2x.svg",
    vector5: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-117@2x.svg",
    vector6: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-118@2x.svg",
    vector7: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-119@2x.svg",
    vector8: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-120@2x.svg",
    vector9: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-278@2x.svg",
    vector10: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-279@2x.svg",
    vector11: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-280@2x.svg",
    vector12: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-281@2x.svg",
    vector13: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-282@2x.svg",
    vector14: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-283@2x.svg",
    vector15: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-127@2x.svg",
    vector16: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-285@2x.svg",
    vector17: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-286@2x.svg",
    vector18: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-287@2x.svg",
    vector19: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-288@2x.svg",
    vector20: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-289@2x.svg",
    vector21: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-133@2x.svg",
    vector22: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-291@2x.svg",
    vector23: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-292@2x.svg",
    vector24: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-293@2x.svg",
    vector25: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-294@2x.svg",
    vector26: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-295@2x.svg",
    vector27: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-296@2x.svg",
    vector28: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-297@2x.svg",
    vector29: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-298@2x.svg",
    vector30: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-299@2x.svg",
    vector31: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-307@2x.svg",
    vector32: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-308@2x.svg",
    vector33: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-309@2x.svg",
    vector34: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-310@2x.svg",
    vector35: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-311@2x.svg",
    vector36: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-300@2x.svg",
    vector37: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-301@2x.svg",
    vector38: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-302@2x.svg",
    vector39: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-303@2x.svg",
    vector40: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-147@2x.svg",
    vector41: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-305@2x.svg",
    vector42: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-306@2x.svg",
    transparency: "Transparency",
    vector43: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-155@2x.svg",
    vector44: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-156@2x.svg",
    cost: "Cost",
    rectangle72: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-72@2x.png",
    place2: "Quality",
    text3:  <>Quality for us, is not just using expensive brands of raw materials, it mainly involves three key points, <br /><ul><li>Right design.</li> <p>By understanding the geological condition of your site as a prerequisite, we provide the customized design for your homesite by adopting inputs from the soil testing that we perform for each construction site.</p><li>Right standard operating procedures.</li><p>Our SOPs ensure we achieve high efficiency, quality outputs, and uniformity of performance.</p><li>Customising the appropriate construction material for specific conditions.<p>  Each brand of construction material has its strengths and weaknesses. We provide suggestions at each stage for specific brands and types of material to use according to your unique condition.</p></li></ul></>,
    rectangle73: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-73@2x.png",
    transparenccy: "Transparency",
    text4: <ul><li>Start your WeBuildd experience by visiting our existing projects of your choice.</li><li>You will receive an extensive list of ongoing and completed projects as a reference.</li><li>Every raw material and process performed at the start is described in an elaborate contract.</li><li> Selection option and final call in your hands. We will have you accompany us to the store for the closing call regarding the type of sanitary fittings, tiles, marbles, paint color, and all other interior items.</li></ul>,
    rectangle70: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-70@2x.png",
    cost2: "Cost",
    text5: "We price you at the actuals, which means there is no premium or additional cost added from us.",
    rectangle77: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-77-2@2x.png",
    whyWebuild: "Founders",
    text2: "There are many variations of passages of Lorem Ipsum available but the majority have suffered dummy alteration in that an some form by the injected humour or randomised words which don’t look even that slightly believable. If you are Lorem Ipsums your need to be sure there isn’t anything embarrassing. There are many variations passages of Lorem as Ipsums available but the majority have suffered that alterations in that some form by injected humour or randomised words which don’t looks even slightly that believable. If you are Lorem as Ipsum  you need to be sure there isn’t anything as embarrassing. There are many variation of passages Lorem Ipsum available but the majority have suffered that a aalteration in that some form by injected humour or randomised words which don’t look even slightly the believable. If you are Lorem Ipsum you need to be sure there is not the anything of embarrassing. If you are Lorem Ipsums your need to be sure there as isn’t anything embarrassing.",
    whyWebuild2: "Founders",
    image3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/image-3-2@2x.png",
    image5: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/image-5-2@2x.png",
    image4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/image-4-2@2x.png",
    frame145Props: frame145Data,
    founderCardProps: founderCardData,
    founderCard32Props: founderCard32Data,
    founderCard2Props: founderCard2Data,
    founderCard4Props: founderCard4Data,
    group8622Props: group8622Data,
    group87Props: group87Data,
    group32Props: group32Data,
    frame5Props: frame5Data,
};

